import { render, staticRenderFns } from "./ModalRequisitos.vue?vue&type=template&id=fbd0008a&"
import script from "./ModalRequisitos.vue?vue&type=script&lang=js&"
export * from "./ModalRequisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports